import { Component } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { BreadcrumbLink } from '../../../../shared/interfaces/breadcrumb-link.interface'
import { BreadcrumbService } from '../../../../shared/services/breadcrumb.service'
import { MetaService } from '../../../../shared/services/meta.service'

@Component({
  selector: 'app-tools-catalogue-contribute',
  templateUrl: './tools-catalogue-contribute.component.html',
  styleUrls: ['./tools-catalogue-contribute.component.scss']
})
export class ToolsCatalogueContributeComponent {
  breadcrumbLinks: BreadcrumbLink[]

  constructor(breadcrumbService: BreadcrumbService, metaService: MetaService) {
    this.breadcrumbLinks = breadcrumbService.getBreadCrumbLinks('toolCatalog', [
      {
        label: 'Contribute',
        path: 'catalogue/contribute'
      }
    ])
    metaService.setTags({
      title: 'Contribute Your Tools and Metrics to our Catalogue',
      description:
        'Do you know of any tools or metrics to help make AI trustworthy? If so, please submit them to our catalogue.',
      path: 'catalogue/contribute',
      absoluteOgImage:
        environment.baseUrl + 'assets/images/catalogue-og-image.png'
    })
  }
}
